import Box from '@mui/material/Box'
import {Text} from '../../1elements'
import GoBackButton from '../../1elements/Buttons/IconButtons/GoBackButton'

const TabInTabLayoutDiv = ({tabTitle, children}) => {
    return (
        <Box
            sx={{
                display: 'grid',
                gap: '20px',
                gridTemplateColumns: '30% 60%',
                gridTemplateRows: '35px 1fr',
                height: '95%',
                justifyContent: 'center',
                marginTop: '15px',
                paddingBottom: '40px'
            }}
        >
            <Box sx={{ display: 'flex', gridColumn: '1/-1', justifyContent: 'space-between' }}>
                <Text type={'adminDashboardTabHeader'}>{tabTitle}</Text>
                <GoBackButton />
            </Box>
            {children}
        </Box>
    )
}

export default TabInTabLayoutDiv
